//for L&TT home url
export const baseUrl = "https://atci.lkm.accenture.com/lttmicrosite-apis"
//